import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@helios/ui';

/**
 * Viewport-locked page chrome. The app shell must not scroll; children fill
 * the remaining height and scroll only inside allocated panels.
 */
export function DensePageShell({ children, className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-dense-page-shell=""
      className={cn('flex h-full min-h-0 min-w-0 flex-1 flex-col overflow-hidden', className)}
      {...props}
    >
      {children}
    </div>
  );
}

/**
 * A height-filling panel. Overflow scrolls here — never on the page.
 */
export function DensePagePanel({ children, className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-dense-page-panel=""
      className={cn(
        'flex min-h-0 min-w-0 flex-1 flex-col overflow-auto [&>*:only-child]:min-h-full [&>*]:min-w-0',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export function DensePageHeaderSlot({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <div className={cn('shrink-0', className)}>{children}</div>;
}
